function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("polygon", {
    style: {
      fill: "#7BCC92"
    },
    points: "176.175,50.339 0.327,152.531 0,267.819 335.825,461.708 511.673,359.516 512,244.228 "
  }), React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "512,244.228 511.673,359.516 335.825,461.708 336.152,346.419  "
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#7BCC92"
    },
    points: "336.152,346.419 335.825,461.708 0,267.819 0.327,152.531  "
  }), React.createElement("polygon", {
    style: {
      fill: "#7BCC92"
    },
    points: "512,244.228 336.152,346.419 0.327,152.531 176.175,50.339  "
  }))), React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M193.395,73.434c-0.853,0.876-1.911,1.7-3.192,2.446c0.001-0.461,0.003-0.923,0.004-1.383 c1.281-0.746,2.34-1.569,3.192-2.446C193.397,72.466,193.396,73.02,193.395,73.434z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M188.648,76.693c0.001-0.461,0.003-0.923,0.004-1.383c0.534-0.251,1.05-0.52,1.546-0.809 c0.003-0.002,0.006-0.003,0.008-0.005c-0.001,0.461-0.002,0.923-0.004,1.383c-0.003,0.002-0.006,0.003-0.008,0.005 C189.697,76.173,189.182,76.443,188.648,76.693z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M188.648,76.693c-0.495,0.233-1.006,0.45-1.53,0.651c0.001-0.461,0.003-0.923,0.004-1.383 c0.523-0.201,1.034-0.418,1.53-0.651C188.65,75.772,188.649,76.233,188.648,76.693z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M162.324,75.887c-1.401-0.809-2.543-1.709-3.439-2.667l0.004-1.383 c0.895,0.957,2.038,1.858,3.439,2.668c6.756,3.901,17.159,4.388,24.793,1.459c-0.001,0.26-0.001,0.52-0.002,0.782 c0,0.027,0,0.064,0,0.091c0,0.053,0,0.124-0.001,0.179c0,0.051,0,0.12-0.001,0.171c0,0.048,0.018,0.117,0,0.162 C179.483,80.274,169.08,79.787,162.324,75.887z"
  })), React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M47.846,152.54l-0.004,1.383c0.008-2.94-1.931-5.884-5.816-8.126 c-1.401-0.809-2.96-1.468-4.615-1.983l0.004-1.383c1.655,0.515,3.214,1.174,4.615,1.983C45.915,146.656,47.854,149.6,47.846,152.54 z"
  }), React.createElement("polygon", {
    style: {
      fill: "#94D6A8"
    },
    points: "333.862,153.148 333.858,154.531 193.395,73.434 193.399,72.051  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "178.362,243.516 178.358,244.899 37.894,163.802 37.898,162.418  "
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M47.846,152.54l-0.004,1.383c-0.008,2.902-1.915,5.8-5.725,8.013 c-1.288,0.749-2.712,1.367-4.225,1.864l0.004-1.383c1.513-0.498,2.936-1.116,4.225-1.864 C45.931,158.341,47.838,155.443,47.846,152.54z"
  }), React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M145.796,199.403l0.004-1.383c0.046-16.248,10.725-32.472,32.057-44.869l-0.004,1.383 C156.52,166.931,145.842,183.155,145.796,199.403z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M178.358,244.899c-21.66-12.505-32.521-28.905-32.563-45.295l0.004-1.383 c0.042,16.39,10.902,32.79,32.562,45.295C178.361,243.93,178.359,244.484,178.358,244.899z"
  }), React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M333.864,153.148l-0.004,1.383c-43.22-24.953-113.067-24.951-156.006,0.003l0.004-1.383 C220.796,128.196,290.644,128.194,333.864,153.148z"
  }), React.createElement("polygon", {
    style: {
      fill: "#94D6A8"
    },
    points: "474.33,234.246 474.326,235.63 333.858,154.531 333.862,153.148  "
  }), React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M366.429,198.646l-0.004,1.383c0.047-16.457-10.816-32.94-32.566-45.498l0.004-1.383 C355.613,165.705,366.476,182.188,366.429,198.646z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M366.426,199.828c0.042,16.315-10.637,32.622-32.057,45.07c0.001-0.461,0.003-0.923,0.004-1.383 c21.42-12.448,32.099-28.755,32.057-45.07C366.428,198.86,366.426,199.414,366.426,199.828z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M464.379,245.509l0.004-1.383c0.008-2.903,1.916-5.801,5.728-8.016 c1.284-0.747,2.707-1.364,4.219-1.862l-0.004,1.383c-1.513,0.498-2.935,1.116-4.22,1.862 C466.295,239.708,464.387,242.607,464.379,245.509z"
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "318.83,324.614 318.826,325.998 178.362,244.901 178.365,243.518  "
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M318.25,252.643c-42.826,16.867-101.733,14.287-139.892-7.744l0.004-1.383 c38.159,22.031,97.066,24.61,139.892,7.744C318.253,251.72,318.251,252.182,318.25,252.643z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M178.898,245.209c-0.18-0.102-0.359-0.206-0.538-0.309l0.004-1.383 c0.179,0.103,0.358,0.206,0.538,0.309C178.901,244.287,178.899,244.749,178.898,245.209z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M334.368,244.898c-5.032,2.925-10.433,5.506-16.119,7.745c0.001-0.461,0.003-0.923,0.004-1.383 c5.684-2.239,11.086-4.82,16.119-7.745C334.37,243.975,334.369,244.437,334.368,244.898z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M464.378,245.509l0.004-1.383c-0.008,2.94,1.932,5.884,5.816,8.126 c1.401,0.809,2.96,1.468,4.615,1.983l-0.004,1.383c-1.656-0.515-3.214-1.174-4.615-1.983 C466.31,251.393,464.37,248.449,464.378,245.509z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M203.553,255.817c-8.824-2.788-17.135-6.324-24.655-10.608c0.001-0.461,0.003-0.923,0.004-1.383 c7.52,4.284,15.83,7.82,24.655,10.608C203.557,254.896,203.554,255.356,203.553,255.817z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M203.553,255.817c0.001-0.461,0.003-0.923,0.004-1.383c0.253,0.08,0.507,0.16,0.762,0.238 c-0.001,0.461-0.003,0.923-0.004,1.383C204.06,255.977,203.807,255.898,203.553,255.817z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M204.569,256.135c-0.085-0.026-0.169-0.052-0.254-0.078c0.001-0.461,0.002-0.923,0.004-1.383 c0.085,0.026,0.169,0.052,0.254,0.078C204.572,255.212,204.57,255.673,204.569,256.135z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M204.57,255.691c0.001-0.313,0.002-0.626,0.003-0.939c8.736,2.692,17.961,4.657,27.409,5.895 c-0.001,0.461-0.003,0.923-0.004,1.383c-9.448-1.239-18.673-3.204-27.409-5.895c0-0.071,0-0.142,0.001-0.213 c0-0.038,0-0.076,0-0.114C204.57,255.768,204.57,255.729,204.57,255.691z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M231.978,262.03c0.001-0.461,0.002-0.923,0.004-1.383c0.092,0.013,0.184,0.024,0.275,0.036 c-0.001,0.461-0.003,0.923-0.004,1.383C232.162,262.054,232.07,262.043,231.978,262.03z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M232.666,262.119c-0.138-0.018-0.276-0.036-0.413-0.053c0.001-0.461,0.003-0.923,0.004-1.383 c0.138,0.018,0.276,0.036,0.413,0.053C232.67,261.15,232.667,261.704,232.666,262.119z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M234.226,262.31c-0.52-0.062-1.041-0.125-1.56-0.191l0.004-1.383 c0.519,0.066,1.039,0.13,1.56,0.191C234.229,261.389,234.227,261.849,234.226,262.31z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M234.227,261.85c0.001-0.308,0.002-0.615,0.003-0.924c0.085,0.01,0.17,0.02,0.255,0.03 c-0.001,0.461-0.003,0.923-0.004,1.383c-0.085-0.01-0.17-0.02-0.255-0.03C234.226,262.158,234.227,262.004,234.227,261.85z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M274.512,262.757c-1.265,0.121-2.535,0.23-3.807,0.325c0.001-0.461,0.003-0.923,0.004-1.383 c1.272-0.095,2.54-0.204,3.807-0.325C274.516,261.789,274.513,262.343,274.512,262.757z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M270.706,263.082c-0.064,0.005-0.129,0.009-0.193,0.015c0.001-0.461,0.003-0.923,0.004-1.383 c0.065-0.005,0.129-0.009,0.193-0.015C270.709,262.161,270.707,262.622,270.706,263.082z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M266.863,263.332c0.001-0.461,0.003-0.923,0.004-1.383c1.218-0.067,2.436-0.144,3.65-0.235 c-0.001,0.461-0.003,0.923-0.004,1.383C269.298,263.187,268.081,263.265,266.863,263.332z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M246.553,263.357c-4.046-0.21-8.077-0.549-12.072-1.017c0.001-0.461,0.003-0.923,0.004-1.383 c3.996,0.468,8.026,0.807,12.072,1.017C246.556,262.388,246.554,262.942,246.553,263.357z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M266.863,263.332c-0.544,0.03-1.09,0.057-1.635,0.083l0.004-1.383 c0.545-0.025,1.091-0.052,1.635-0.082C266.866,262.409,266.865,262.87,266.863,263.332z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M333.864,153.148c43.223,24.955,43.448,65.414,0.509,90.367 c-5.032,2.925-10.433,5.506-16.119,7.745c-42.826,16.867-101.733,14.287-139.892-7.744c-43.22-24.953-43.444-65.412-0.505-90.365 C220.796,128.196,290.644,128.194,333.864,153.148z"
  })), React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M353.339,324.828l-0.004,1.383c-0.894-0.957-2.038-1.858-3.439-2.668 c-7.719-4.457-20.197-4.457-27.865,0c-1.288,0.748-2.349,1.575-3.205,2.452l0.004-1.383c0.856-0.878,1.916-1.703,3.205-2.452 c7.668-4.457,20.147-4.457,27.865,0C351.301,322.971,352.443,323.871,353.339,324.828z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M176.125,50.292L511.95,244.18L336.102,346.373L0.277,152.484L176.125,50.292z M353.337,324.828 l121.476-70.594c-1.656-0.515-3.214-1.174-4.615-1.983c-7.719-4.456-7.759-11.685-0.088-16.143c1.285-0.747,2.707-1.364,4.22-1.862 l-140.468-81.1L193.399,72.051c-0.855,0.878-1.915,1.704-3.202,2.451c-7.672,4.459-20.151,4.459-27.87,0.002 c-1.401-0.809-2.543-1.709-3.439-2.668L37.414,142.43c1.656,0.515,3.214,1.174,4.615,1.983c7.719,4.456,7.76,11.684,0.092,16.141 c-1.288,0.748-2.712,1.366-4.225,1.864l140.464,81.097c15.502,8.951,34.428,14.69,54.311,17.22 c-19.881-2.53-38.806-8.269-54.306-17.218l140.465,81.098c0.855-0.878,1.916-1.704,3.205-2.453c7.668-4.457,20.147-4.457,27.865,0 C351.3,322.971,352.442,323.871,353.337,324.828"
  }), React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M333.864,153.148c-43.22-24.953-113.067-24.951-156.006,0.003 c-42.939,24.953-42.715,65.412,0.505,90.365L37.898,162.418c1.513-0.498,2.935-1.116,4.223-1.864 c7.669-4.456,7.628-11.684-0.091-16.141c-1.401-0.809-2.96-1.468-4.615-1.983l121.476-70.594c0.894,0.957,2.038,1.858,3.439,2.668 c7.719,4.456,20.197,4.456,27.868-0.002c1.284-0.746,2.346-1.573,3.202-2.45L333.864,153.148z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M158.889,71.838L37.414,142.431c0.502,0.156,0.974,0.351,1.457,0.534l120.016-69.746 L158.889,71.838z"
  }), React.createElement("path", {
    style: {
      fill: "#94D6A8"
    },
    d: "M274.517,261.374c-3.079,0.295-6.177,0.514-9.285,0.656 C268.339,261.888,271.436,261.669,274.517,261.374z"
  })), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "474.814,254.235 474.81,255.619 353.334,326.212 353.339,324.828  "
  }), React.createElement("path", {
    style: {
      fill: "#4DBA69"
    },
    d: "M474.33,234.246c-1.513,0.498-2.935,1.116-4.219,1.862c-7.672,4.459-7.631,11.686,0.087,16.143 c1.401,0.809,2.96,1.468,4.615,1.983l-121.476,70.594c-0.894-0.957-2.038-1.858-3.439-2.668c-7.719-4.457-20.197-4.457-27.865,0 c-1.288,0.748-2.349,1.575-3.205,2.452l-140.464-81.097c38.156,22.029,97.063,24.608,139.889,7.742 c5.684-2.239,11.086-4.82,16.119-7.745c42.939-24.953,42.715-65.412-0.509-90.367L474.33,234.246z"
  }))), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.16,211.291 335.985,405.313 335.99,403.357 0.166,209.335  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.117,226.519 335.942,420.541 335.947,418.584 0.122,224.562  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.139,218.905 335.963,412.927 335.969,410.971 0.144,216.948  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.095,234.132 335.92,428.155 335.926,426.198 0.101,232.176  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "335.84,456.654 0.015,262.631 0.009,264.588 335.834,458.61  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.031,256.974 335.855,450.996 335.862,449.04 0.037,255.018  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.052,249.361 335.877,443.383 335.882,441.426 0.057,247.404  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.074,241.747 335.899,435.768 335.904,433.812 0.079,239.789  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.289,165.608 336.114,359.63 336.12,357.674 0.296,163.651  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.269,173.222 336.092,367.244 336.099,365.287 0.274,171.265  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.182,203.677 336.007,397.7 336.012,395.743 0.187,201.721  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.317,156.038 0.311,157.994 336.136,352.017 336.142,350.06  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.204,196.064 336.029,390.085 336.034,388.128 0.209,194.107  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.247,180.835 336.072,374.858 336.077,372.901 0.252,178.879  "
  }), React.createElement("polygon", {
    style: {
      fill: "#65C27C"
    },
    points: "0.225,188.449 336.05,382.471 336.056,380.515 0.231,186.493  "
  })), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.926,426.051 335.921,428.016 511.768,326.107 511.773,324.143  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.948,418.413 335.942,420.377 511.79,318.468 511.795,316.504  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.904,433.69 335.899,435.655 511.746,333.747 511.752,331.781  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.969,410.773 335.964,412.738 511.811,310.83 511.817,308.865  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.834,458.571 511.681,356.663 511.687,354.698 335.84,456.607  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.862,448.968 335.855,450.932 511.703,349.024 511.708,347.06  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.883,441.328 335.877,443.294 511.724,341.385 511.73,339.42  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "336.013,395.495 336.007,397.46 511.855,295.551 511.86,293.587  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "336.1,364.94 336.094,366.904 511.941,264.997 511.947,263.032  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "336.121,357.301 336.115,359.266 511.962,257.357 511.969,255.393  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "336.143,349.663 336.137,351.627 511.984,249.719 511.99,247.754  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "336.035,387.857 336.029,389.821 511.876,287.913 511.882,285.948  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "335.991,403.134 335.986,405.1 511.833,303.191 511.838,301.226  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "336.078,372.578 336.073,374.544 511.92,272.636 511.925,270.67  "
  }), React.createElement("polygon", {
    style: {
      fill: "#4DBA69"
    },
    points: "336.056,380.217 336.051,382.183 511.898,280.274 511.904,278.31  "
  })), React.createElement("polygon", {
    style: {
      fill: "#E0E0E2"
    },
    points: "278.66,109.211 101.705,212.115 101.333,327.578 175.756,370.546 176.129,255.084  353.083,152.178 "
  }), React.createElement("polyline", {
    style: {
      fill: "#D8D8DA"
    },
    points: "176.129,255.084 101.705,212.115 101.333,327.578 175.756,370.546 176.129,255.084 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.4dadb556.svg";
export { ForwardRef as ReactComponent };